import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowLeft } from 'lucide-react';
import FAQ from '../components/FAQ';

const FAQPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Set page title
    document.title = 'FAQ - baad.tv | Frequently Asked Questions';
    
    // Scroll to top on mount
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="faq-page">
      <div className="faq-page-header">
        <Button 
          onClick={() => navigate('/')}
          variant="outline"
          className="back-button"
        >
          <ArrowLeft size={20} />
          <span>Back to Home</span>
        </Button>
        
        <div className="logo-container">
          <img 
            src="/sheep-logo.png" 
            alt="baad.tv - Free Social TV Tracker" 
            className="faq-logo"
            width="80"
            height="80"
          />
        </div>
      </div>

      <FAQ showTitle={true} />

      <div className="faq-cta">
        <h3>Ready to join the flock?</h3>
        <p>Start tracking your TV shows and connect with friends today!</p>
        <Button 
          onClick={() => navigate('/')}
          size="lg"
          className="cta-button"
        >
          Get Started - It's Free!
        </Button>
      </div>

      <style jsx>{`
        .faq-page {
          min-height: 100vh;
          background: #121212;
          color: #ffffff;
          padding-bottom: 4rem;
        }

        .faq-page-header {
          max-width: 1200px;
          margin: 0 auto;
          padding: 2rem 1.5rem;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .back-button {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          background: transparent;
          border: 1px solid #E62F88;
          color: #E62F88;
          padding: 0.75rem 1.5rem;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.2s;
        }

        .back-button:hover {
          background: rgba(230, 47, 136, 0.1);
          color: #ffffff;
        }

        .logo-container {
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
        }

        .faq-logo {
          width: 80px;
          height: 80px;
          object-fit: contain;
        }

        .faq-cta {
          max-width: 600px;
          margin: 4rem auto 0;
          padding: 3rem 2rem;
          text-align: center;
          background: linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 100%);
          border: 2px solid #E62F88;
          border-radius: 12px;
        }

        .faq-cta h3 {
          font-size: 2rem;
          font-weight: 700;
          color: #ffffff;
          margin-bottom: 1rem;
        }

        .faq-cta p {
          font-size: 1.1rem;
          color: #b0b0b0;
          margin-bottom: 2rem;
        }

        .cta-button {
          background: #E62F88;
          color: #000000;
          padding: 1rem 2rem;
          font-size: 1.1rem;
          font-weight: 600;
          border: none;
          cursor: pointer;
          transition: all 0.2s;
        }

        .cta-button:hover {
          background: #c7266e;
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(230, 47, 136, 0.4);
        }

        @media (max-width: 768px) {
          .faq-page-header {
            padding: 1.5rem 1rem;
            flex-direction: column;
            gap: 1.5rem;
          }

          .logo-container {
            position: static;
            transform: none;
          }

          .faq-logo {
            width: 60px;
            height: 60px;
          }

          .faq-cta {
            margin: 3rem 1rem 0;
            padding: 2rem 1.5rem;
          }

          .faq-cta h3 {
            font-size: 1.5rem;
          }

          .faq-cta p {
            font-size: 1rem;
          }

          .cta-button {
            padding: 0.875rem 1.5rem;
            font-size: 1rem;
          }
        }
      `}</style>
    </div>
  );
};

export default FAQPage;
